import {
  AutocompleteInput,
  ReferenceInput,
  required,
} from "react-admin";
import MuiDatePickerInput from "../../common/MuiDatePickerInput";
import {
  inputTextKind,
  matchSuggestionKind,
  filterToQueryKind,
  OptionRendererKind,
} from "../../common/OptionRendererKind";

const salesmanPenaltyDetailFilterList = () => [
  <MuiDatePickerInput
    alwaysOn
    source="start_date"
    label="mine.label.start_date"
    variant="outlined"
    maxDateSource="end_date"
  />,
  <MuiDatePickerInput
    alwaysOn
    source="end_date"
    label="mine.label.end_date"
    variant="outlined"
    minDateSource="start_date"
  />,
  <ReferenceInput
    alwaysOn
    source="salesman_id"
    reference="salesmen"
    perPage={10}
    sort={{
      field: "salesmen.code",
      order: "ASC",
    }}
    filter={{ "salesmen.active": "1" }}
  >
    <AutocompleteInput
      variant="outlined"
      fullWidth
      optionValue="id"
      optionText={<OptionRendererKind />}
      inputText={inputTextKind}
      matchSuggestion={matchSuggestionKind}
      filterToQuery={filterToQueryKind}
      validate={required()}
    />
  </ReferenceInput>,
];

export default salesmanPenaltyDetailFilterList;
